import { render, staticRenderFns } from "./PriceTableSidebar.vue?vue&type=template&id=77610cef&"
import script from "./PriceTableSidebar.vue?vue&type=script&lang=js&"
export * from "./PriceTableSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77610cef')) {
      api.createRecord('77610cef', component.options)
    } else {
      api.reload('77610cef', component.options)
    }
    module.hot.accept("./PriceTableSidebar.vue?vue&type=template&id=77610cef&", function () {
      api.rerender('77610cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/price-table/PriceTableSidebar.vue"
export default component.exports